import React from "react";
import { ReactComponent as DOWNLOAD } from "../img/skill_icons/download.svg";

export const Download = () => {
  return <DOWNLOAD title="download" />;
};
